import { T, F } from './tokens';

const CAT_COLORS: Record<string, string> = {
  Clinical: T.info,
  Conversational: '#7C3AED',
  Compliance: T.warning,
  Pricing: T.success,
};

interface ValidationCheckProps {
  name: string;
  category: string;
  passed: boolean;
  reasoning?: string;
  expanded?: boolean;
  onToggle?: () => void;
}

export function ValidationCheck({
  name, category, passed, reasoning, expanded, onToggle,
}: ValidationCheckProps) {
  const catColor = CAT_COLORS[category] || T.textMuted;

  return (
    <div style={{ marginBottom: 6 }}>
      <div
        onClick={onToggle}
        style={{
          display: 'flex', alignItems: 'center', gap: 10,
          padding: '10px 14px',
          background: T.bgCard,
          borderRadius: expanded ? '6px 6px 0 0' : T.radius.md,
          border: `1px solid ${T.border}`,
          cursor: onToggle ? 'pointer' : 'default',
        }}
      >
        <div style={{
          width: 28, height: 28, borderRadius: 14,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: passed ? T.successSoft : T.dangerSoft,
          fontSize: 13, color: passed ? T.success : T.danger, fontWeight: 700,
        }}>
          {passed ? '\u2713' : '\u2717'}
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 13, fontWeight: 500, color: T.text, fontFamily: F.body }}>
            {name}
          </div>
        </div>
        <span style={{
          fontSize: 9, padding: '2px 6px', borderRadius: 99,
          fontFamily: F.mono, fontWeight: 600, letterSpacing: 0.5,
          background: `${catColor}12`, color: catColor,
        }}>
          {category.toUpperCase()}
        </span>
        {onToggle && (
          <span style={{
            fontSize: 12, color: T.textGhost,
            transform: expanded ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.2s',
          }}>
            &#9662;
          </span>
        )}
      </div>
      {expanded && reasoning && (
        <div style={{
          padding: '10px 14px', background: T.bgSoft,
          borderRadius: '0 0 6px 6px',
          border: `1px solid ${T.border}`, borderTop: 'none',
        }}>
          <p style={{
            fontSize: 12, color: T.textMuted, fontStyle: 'italic',
            lineHeight: 1.5, margin: 0, fontFamily: F.body,
          }}>
            {reasoning}
          </p>
        </div>
      )}
    </div>
  );
}
